import { buybackCustomerAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { defineStore } from 'pinia'

import {
  type Estimation,
  getEstimationSwapPriceAdapter,
} from '~/scopes/buyback/api/adapters/getEstimationSwapPrice.adapter'

export enum EndpointStatus {
  IDLE,
  PENDING,
  RESOLVED,
  REJECTED,
}

export interface Swap {
  estimations: Array<Estimation>
  enabled: boolean
  status: EndpointStatus
}

export const useSwapStore = defineStore('swap', {
  state: (): Swap => ({
    estimations: [],
    enabled: true,
    status: EndpointStatus.IDLE,
  }),
  actions: {
    resetEstimations() {
      this.estimations = []
    },
    async fetchSwapEstimations(listings: Array<number>) {
      this.status = EndpointStatus.PENDING
      try {
        const response: Array<buybackCustomerAPI.SwapListingOffer> | null =
          await $httpFetch(buybackCustomerAPI.getEstimationSwapPrice, {
            queryParams: {
              listing_id: listings,
            },
          })
        if (response) {
          this.estimations = getEstimationSwapPriceAdapter(response)
        }
        this.status = EndpointStatus.RESOLVED
      } catch (error) {
        this.status = EndpointStatus.REJECTED
      }
    },
  },
})
